import { BasicRequest } from "./basicRequest";

export class MoovDefinitionsRequest extends BasicRequest{
    public moovDefinitionIdList: number[] =[];
}